import React, { useState } from "react";
import {
  Box,
  Text,
  Button,
  SimpleGrid,
  Input,
  Select,
  Textarea,
  Flex,
  Icon,
} from "@chakra-ui/react";
import { EmailIcon } from "@chakra-ui/icons";
import { FaSms, FaBell } from "react-icons/fa";
import Navbar from "../../Navbar/Navbar";
import Sidebar from "../../Sidebar";

const ChannelCard = ({ active, icon, label, onClick }) => (
  <Box
    border="1px solid"
    borderColor={active ? "#5e72e4" : "#e2e8f0"}
    borderRadius="12px"
    p={6}
    textAlign="center"
    cursor="pointer"
    position="relative"
    onClick={onClick}
    bg={active ? "rgba(94, 114, 228, 0.05)" : "white"}
    transition="all 0.2s"
    _hover={{ borderColor: "#5e72e4", transform: "translateY(-2px)" }}
    boxShadow={active ? "0 4px 12px rgba(94, 114, 228, 0.15)" : "none"}
  >
    {active && (
      <Box
        position="absolute"
        top="-1px"
        right="-1px"
        bg="#5e72e4"
        color="white"
        p={1}
        borderTopRightRadius="12px"
        borderBottomLeftRadius="12px"
        fontSize="xs"
      >
        ✓
      </Box>
    )}
    <Icon as={icon} boxSize={6} mb={3} color={active ? "#5e72e4" : "gray.500"} />
    <Text fontWeight="600" fontSize="sm" color={active ? "#344767" : "#67748e"}>{label}</Text>
  </Box>
);

const NotificationPage = () => {
  const [channel, setChannel] = useState("email");
  const SIDEBAR_WIDTH = "240px";

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box
        p={{ base: 4, md: 8 }}
        bg="#f8f9fd"
        minH="100vh"
        mt="80px"
        ml={{ base: 0, md: SIDEBAR_WIDTH }}
      >
        <Box mb={8}>
          <Flex align="center" mb={1}>
            <Icon as={FaBell} boxSize={6} color="#5e72e4" mr={3} />
            <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="800" color="#32325d">
              Send Notification
            </Text>
          </Flex>
          <Text fontSize="sm" color="#8898aa" fontWeight="500">
            Broadcast messages to your users across multiple channels
          </Text>
        </Box>

        <Box
          bg="white"
          p={{ base: 6, md: 10 }}
          borderRadius="16px"
          boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
          border="1px solid #f0f2f5"
        >
          {/* Channel Tabs */}
          <Text fontSize="sm" fontWeight="600" color="#525f7f" mb={4}>Select Channel</Text>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} mb={8}>
            <ChannelCard
              active={channel === "email"}
              icon={EmailIcon}
              label="Send Via Email"
              onClick={() => setChannel("email")}
            />
            <ChannelCard
              active={channel === "sms"}
              icon={FaSms}
              label="Send Via SMS"
              onClick={() => setChannel("sms")}
            />
            <ChannelCard
              active={channel === "firebase"}
              icon={FaBell}
              label="Send Via Firebase"
              onClick={() => setChannel("firebase")}
            />
          </SimpleGrid>

          {/* Common Field */}
          <Box mb={6}>
            <Text fontSize="sm" fontWeight="600" color="#525f7f" mb={2}>Being Sent To *</Text>
            <Select
              borderRadius="8px"
              borderColor="#e2e8f0"
              fontSize="sm"
              _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
            >
              <option>All Bettors</option>
              <option>Verified Users</option>
            </Select>
          </Box>

          {/* ========== EMAIL ========== */}
          {channel === "email" && (
            <>
              <Box mb={6}>
                <Text fontSize="sm" fontWeight="600" color="#525f7f" mb={2}>Subject *</Text>
                <Input
                  placeholder="Email Subject"
                  borderRadius="8px"
                  fontSize="sm"
                  _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
                />
              </Box>

              <Box mb={6}>
                <Text fontSize="sm" fontWeight="600" color="#525f7f" mb={2}>Message *</Text>
                <Box border="1px solid #e2e8f0" borderRadius="8px" overflow="hidden">
                  <Flex bg="#f8f9fa" p={2} gap={2} borderBottom="1px solid #e2e8f0">
                    <Button size="xs" variant="ghost">B</Button>
                    <Button size="xs" variant="ghost">I</Button>
                    <Button size="xs" variant="ghost">U</Button>
                  </Flex>
                  <Textarea
                    minH="200px"
                    border="none"
                    placeholder="Email message..."
                    fontSize="sm"
                    _focus={{ boxShadow: "none" }}
                  />
                </Box>
              </Box>
            </>
          )}

          {/* ========== SMS ========== */}
          {channel === "sms" && (
            <Box mb={6}>
              <Text fontSize="sm" fontWeight="600" color="#525f7f" mb={2}>SMS Message *</Text>
              <Textarea
                maxLength={160}
                placeholder="Type SMS (max 160 characters)"
                borderRadius="8px"
                minH="120px"
                fontSize="sm"
                _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
              />
            </Box>
          )}

          {/* ========== FIREBASE ========== */}
          {channel === "firebase" && (
            <>
              <Box mb={6}>
                <Text fontSize="sm" fontWeight="600" color="#525f7f" mb={2}>Notification Title *</Text>
                <Input
                  placeholder="Firebase Title"
                  borderRadius="8px"
                  fontSize="sm"
                  _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
                />
              </Box>

              <Box mb={6}>
                <Text fontSize="sm" fontWeight="600" color="#525f7f" mb={2}>Notification Message *</Text>
                <Textarea
                  placeholder="Short notification message"
                  borderRadius="8px"
                  minH="100px"
                  fontSize="sm"
                  _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
                />
              </Box>
            </>
          )}

          {/* Bottom Fields */}
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} mb={10}>
            <Box>
              <Text fontSize="sm" fontWeight="600" color="#525f7f" mb={2}>Start From *</Text>
              <Input
                placeholder="User ID e.g. 1"
                borderRadius="8px"
                fontSize="sm"
                _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
              />
            </Box>

            <Box>
              <Text fontSize="sm" fontWeight="600" color="#525f7f" mb={2}>Per Batch *</Text>
              <Flex>
                <Input
                  placeholder="100"
                  borderRightRadius="0"
                  borderRadius="8px"
                  fontSize="sm"
                  _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
                />
                <Box bg="#f8f9fa" px={4} display="flex" alignItems="center" border="1px solid #e2e8f0" borderLeft="none" borderRightRadius="8px" fontSize="xs" fontWeight="600" color="#8898aa">
                  Users
                </Box>
              </Flex>
            </Box>

            <Box>
              <Text fontSize="sm" fontWeight="600" color="#525f7f" mb={2}>Cooling Period *</Text>
              <Flex>
                <Input
                  placeholder="10"
                  borderRightRadius="0"
                  borderRadius="8px"
                  fontSize="sm"
                  _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
                />
                <Box bg="#f8f9fa" px={4} display="flex" alignItems="center" border="1px solid #e2e8f0" borderLeft="none" borderRightRadius="8px" fontSize="xs" fontWeight="600" color="#8898aa">
                  Seconds
                </Box>
              </Flex>
            </Box>
          </SimpleGrid>

          <Button
            bg="#5e72e4"
            color="white"
            width="100%"
            size="lg"
            _hover={{ bg: "#4e62d4", transform: "translateY(-1px)" }}
            _active={{ bg: "#3e52c4" }}
            borderRadius="12px"
            fontSize="md"
            fontWeight="700"
            boxShadow="0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)"
          >
            Submit Notification
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default NotificationPage;

